import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AlgoliaReaction } from 'containers/user_reactions/types';
interface IstyleState {
    liststyle: any[];
    valueSearch: String;
    listStyleStylist: any[];
    isSearch: Boolean;
    reactedItems: AlgoliaReaction[];
    reactedItemsUnProcessed: AlgoliaReaction[];
}
const initialState: IstyleState = {
    liststyle: [],
    valueSearch: '',
    listStyleStylist: [],
    isSearch: false,
    reactedItems: [],
    reactedItemsUnProcessed: [],
};
// Action =====================================================
const styleSlice = createSlice({
    name: 'style',
    initialState,
    reducers: {
        getListstyle: (state, action) => {
            state.liststyle = action.payload;
        },
        getValueSearch: (state, action) => {
            state.valueSearch = action.payload;
        },
        getListStyleStylist: (state, action) => {
            state.listStyleStylist = action.payload;
        },
        statusSearch: (state, action) => {
            state.isSearch = action.payload;
        },
        setReactedItems: (state, action: PayloadAction<AlgoliaReaction[]>) => {
            state.reactedItems = action.payload;
        },
        setUnProcessedReactedItems: (state, action: PayloadAction<AlgoliaReaction[]>) => {
            state.reactedItemsUnProcessed = action.payload;
        },
    },
});

// Selector =====================================================
export const {
    getListstyle,
    getValueSearch,
    getListStyleStylist,
    statusSearch,
    setReactedItems,
    setUnProcessedReactedItems,
} = styleSlice.actions;
// Reducer=====================================================
const styleReducer = styleSlice.reducer;
export default styleReducer;
